import React, { useEffect, useState } from "react";
import axiosInstance from "../services/axiosComman";

function useDashboardStatus({url}) {
  const [isReveiw,setIsReview]= useState(false);
  const [completePercentage,setCompletePercentage] =useState(0);
  const [loading, setLoading] = useState(false);
  async function getData() {
    setLoading(true);
    await axiosInstance
      .get(url)
      .then((res) => {
        let data = res?.data?.data;
        setCompletePercentage(data?.complete_percentage||0);
        setIsReview(data?.verified_and_approved||false);
        setLoading(false);
      }).catch((err) => {
        console.error(err?.response?.data);
        setLoading(false);
      });
  }
  useEffect(() => {
    if (url) getData();
  }, [url]);
  return { completePercentage,isReveiw,getData,loading };
}

export default useDashboardStatus;
